/* eslint-disable no-nested-ternary */
import OptionHOC from '@platform/react/hoc/autocomplete/option'
import { Grid } from '@mui/material'
import AvatarImage from 'ui/Element/Image/Avatar'
import Text from 'ui/Element/Text'
import { getSubLabel } from 'lib/util/string'
import { getDocumentationIcon } from 'lib/util/icon'

const styles = () => ({
  option: {
    gap: '0.75rem',
  },
  subLabel: {
    gap: '0.25rem',
  },
  avatar: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays an Equipment for the {@link Autocomplete} component. Will display a top label consisting
 * of the type of part (part or assembly) and additionally where it's assembled in. Will also
 * display a sublabel showing its order number, if available.
 *
 * @param {Object} classes  styling for the option
 * @param {Object} props    props for the option
 *
 * @returns {*}
 */
const EquipmentOption = (classes, props = {}) => {
  const { option, labels } = props || {}

  const icon = getDocumentationIcon({
    name: option.value?.productType,
    nodeType: 'product',
  })

  const {
    value: {
      image = null,
      serialLong,
      info1,
      label,
    } = {},
  } = option || {}

  const { serial: serialLabel } = labels || {}

  const subLabel = getSubLabel(Text, [serialLabel, serialLong || info1])

  const attachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image.id, api: { ref: 'equipment' } }
    : { value: { name: '' } }

  return (
    <Grid
      container
      direction={'row'}
      className={classes.option}
    >
      <Grid className={classes.avatar}>
        <AvatarImage
          shape={'circle'}
          fit={'contain'}
          attachment={attachment}
          fallbackIcon={{
            source: icon || {},
            name: 'monitor',
            color: 'text.regular',
            background: 'gray.960',
          }}
        />
      </Grid>
      <Grid
        item
        ms={'auto'}
        alignSelf={'stretch'}
      >
        <Grid
          container
          height={'100%'}
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={1}
            value={label}
            variant={'14/bold'}
            color={'black.main'}
          />
          {serialLabel && (serialLong || info1) && (
            <Grid
              item
              container
              ms={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OptionHOC(EquipmentOption, styles)
